export const colors = {
  primary: {
    main: '#878787',
    light: '#c4c4c4',
    dark: '#5f5f5f',
    active: '#878787',
    gradient: 'linear-gradient(145deg, #878787, #c4c4c4)'
  },
  secondary: {
    main: '#f39c12',
    light: '#ffce54',
    dark: '#b36b00',
    active: '#f39c12',
    gradient: 'linear-gradient(145deg, #f39c12, #ffce54)'
  },
  background: {
    default: '#eef1f6',
    dark: '#0d2e44'
  },
  text: {
    primary: '#252525',
    secondary: '#878787',
    disabled: '#c4c4c4',
    hint: '#5f5f5f',
    icon: '#5f5f5f',
    active: '#252525'
  },
  info: {
    // main: '#03a9f5',
    main: '#4da6ea',
    light: '#67daff',
    dark: '#007ac1',
    active: '#03a9f5',
    note: '#d9edf7',
    gradient: 'linear-gradient(145deg, #a3e3ff, #89bfe2)'
  },
  success: {
    // main: '#57d6a5',
    main: '#35c492',
    light: '#37e5a8',
    // light: '#6effe8',
    // dark: '#00b686',
    dark: '#27936e',
    active: '#1de9b6',
    gradient: 'linear-gradient(145deg, #a4f4db, #85d3b6)'
  },
  error: {
    main: '#f16d5c',
    light: '#ff7f6a',
    dark: '#af1a12',
    active: '#e74c3c',
    gradient: 'linear-gradient(145deg, #ffb4aa, #dd978f)'
  },
  warning: {
    main: '#f39c12',
    light: '#fce5cd',
    dark: '#b36b00',
    active: '#f39c12',
    gradient: 'linear-gradient(145deg, #ffdc9f, #e1b986)'
  },
  white: {
    main: '#ffffff'
  },
  grey: {
    400: '#bdbdbd',
    300: '#c4c4c4',
    200: '#e7e7e7',
    100: '#f1f1f1'
  },
  gradient: {
    warning: 'linear-gradient(145deg, #ffdc9f, #e1b986)',
    error: 'linear-gradient(145deg, #ffb4aa, #dd978f)',
    success: 'linear-gradient(145deg, #a4f4db, #85d3b6)',
    info: 'linear-gradient(145deg, #a3e3ff, #89bfe2)',
    primary: 'linear-gradient(145deg, #c7c7c7, #c1c1c1)',
    secondary: 'linear-gradient(145deg, #f39c12, #ffce54)'
  }
}
